module.exports = __webpack_public_path__ + "static/media/Square_List.6ba1bce2.svg";